<template>
  <transition name="modal">
    <div class="modal-mask" tabindex="0" @keydown.esc="$emit('close')">
        <div class="modal-wrapper-close" @click="$emit('close')"></div>
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close">
            <button class="modal-default-button" @click="$emit('close')">X</button>
          </div>
          <div class="modal-content">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  mounted(){
    document.body.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    });

    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);

    player.on('play', function() {
        iframe.blur();
    });
    player.on('pause', function() {
        iframe.blur();
    });
    player.on('ended', function() {
        iframe.blur();
    });
    player.on('timeupdate', function() {
        iframe.blur();
    });
    player.on('progress', function() {
        iframe.blur();
    });
    player.on('volumechange', function() {
        iframe.blur();
    });
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?68d42008